import type { SolutionsPage } from '~/types/pages.types'

import type { Page } from '~/composables/useApiFetch.composables'

const SOLUTIONS_PAGE_KEY = 'solutions'

export function useSolutionsPage(
    immediate = true,
    includeSolutions = true,
    options: Parameters<typeof useApiFetch<Page<SolutionsPage>>>[1] = {}
) {
    const nuxtApp = useNuxtApp()

    return useApiFetch<Page<SolutionsPage>>('/v1/pages/solutions', {
        key: includeSolutions ? SOLUTIONS_PAGE_KEY : 'solutions-page',
        dedupe: 'defer',
        immediate,
        query: includeSolutions
            ? {
                  include: 'solutions',
              }
            : undefined,
        getCachedData(key) {
            return nuxtApp.payload?.data?.[key]
        },
        ...options,
    })
}
